import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const SoundOffIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="soundOff" ref={ref} {...props}>
      <path d="M20.53,6.15,19,7.67A8.51,8.51,0,0,1,20.19,12a8.65,8.65,0,0,1-4.89,7.76.72.72,0,0,1-.32.08.75.75,0,0,1-.33-1.43,7.1,7.1,0,0,0,3.26-9.64l-1.29,1.29A5.25,5.25,0,0,1,17,12v0a5.4,5.4,0,0,1-2.81,4.74.8.8,0,0,1-.36.09.75.75,0,0,1-.36-1.4,3.92,3.92,0,0,0,2-3.43v0a3.38,3.38,0,0,0-.07-.72l-4.07,4.07v1.6a.76.76,0,0,1-.41.67.84.84,0,0,1-.34.08.8.8,0,0,1-.45-.14l-.59-.42L6.91,19.77a.75.75,0,0,1-1.06,0,.75.75,0,0,1,0-1.06L19.47,5.09a.75.75,0,0,1,1.06,1.06Zm-9.61.22a.76.76,0,0,0-.78.06L6.26,9.26H4.56a.74.74,0,0,0-.75.75v4a.74.74,0,0,0,.75.75H6.27c.13.11.28.22.45.34a.74.74,0,0,0,.44.14.75.75,0,0,0,.45-1.35L7,13.37H7a.78.78,0,0,0-.49-.15H5.31V10.76h1.2A.71.71,0,0,0,7,10.61l2.89-2.1v2.08a.75.75,0,0,0,1.5,0V7A.75.75,0,0,0,10.92,6.37Zm5.74-1.32a7.87,7.87,0,0,0-1.36-.81.75.75,0,1,0-.65,1.35,7.06,7.06,0,0,1,1.12.67.74.74,0,0,0,.44.14.73.73,0,0,0,.61-.31A.75.75,0,0,0,16.66,5.05Z" />
    </Icon>
  ),
) as IconWithRender;

SoundOffIcon.displayName = 'SoundOffIcon';
SoundOffIcon.renderIcon = (props) => <SoundOffIcon {...props} />;
export default SoundOffIcon;
